const Loading = {
    namespaced: true,

    state: {
        isLoading: false
    },

    getters: {

        /**
         * Флаг загрузки
         * @param state
         * @returns {*}
         */
        isLoading (state) {
            return state.isLoading;
        }
    },

    mutations: {

        /**
         * Изменение состояния загрузки
         * @param state
         * @param status
         */
        switchIsLoading (state, status) {
            state['isLoading'] = status;
            console.log('isLoading = ' + status);
        }
    },


    actions: {

        /**
         * Асинхронный вызов изменения состояния загрузки
         * @param commit
         * @param status
         */
        isLoading ({ commit }, status) {
            commit('switchIsLoading', status);
        }
    },
};

export default Loading;


// WEBPACK FOOTER //
// ./src/store/modules/loading.js